import {
  WAITING_TRANSCRIPTION,
  TRANSCRIPTION_IN_PROGRESS,
  WAITING_TRANSCRIPTION_APPROVE,
  WAITING_TRANSCRIPTION_COMPARE,
  SCHEDULED_PRODUCTION,
  TRANSCRIPTION_APPROVED,
  TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION,
  TRANSCRIPTION_DENIED,
  CANCELED_IN_PRODUCTION
} from '@/settings/consts/transcription-status';

function getTranscriptionStatus(): any[] {
  const transcriptionStatus = {
    WAITING_TRANSCRIPTION,
    TRANSCRIPTION_IN_PROGRESS,
    WAITING_TRANSCRIPTION_APPROVE,
    SCHEDULED_PRODUCTION,
    TRANSCRIPTION_APPROVED,
    TRANSCRIPTION_DENIED,
    CANCELED_IN_PRODUCTION
    
  };

  const status = Object.keys(transcriptionStatus).map((key) => {
    return transcriptionStatus[key];
  });

  return status.filter((item) => item.showInFilter);
}

function isWaitingTranscription(status: string): boolean {
  return status === WAITING_TRANSCRIPTION.key;
}

function isWaitingTranscriptionApprove(status: string): boolean {
  return status === WAITING_TRANSCRIPTION_APPROVE.key;
}

function isTranscriptionInProgress(status: string): boolean {
  return status === TRANSCRIPTION_IN_PROGRESS.key;
}

function isWaitingTranscriptionCompare(status: string): boolean {
  return status === WAITING_TRANSCRIPTION_COMPARE.key;
}

function isTranscriptionApproved(status: string): boolean {
  return status === TRANSCRIPTION_APPROVED.key;
}

function isTranscriptionDenied(status: string): boolean {
  return status === TRANSCRIPTION_DENIED.key;
}

function isErrorOnSentToProduction(status: string): boolean {
  return status === TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION.key;
}

export {
  getTranscriptionStatus,
  isWaitingTranscription,
  isWaitingTranscriptionApprove,
  isTranscriptionInProgress,
  isWaitingTranscriptionCompare,
  isTranscriptionApproved,
  isTranscriptionDenied,
  isErrorOnSentToProduction,
};
